import { useRef } from 'react';
import { useVideoCallStore } from '../../telemed/state/video-call/video-call.store';
import { APP_TELEMED_LOCAL_INITIAL, useAppTelemedLocalStore } from '../stores/appointment/appointment.store';
import { useExamObservationsStore } from '../stores/appointment/exam-observations.store';

export const useResetAppointmentStore = (appointmentId?: string): void => {
  const didResetRef = useRef(false);

  if (!didResetRef.current) {
    useExamObservationsStore.setState({}, true);
    useAppTelemedLocalStore.setState(APP_TELEMED_LOCAL_INITIAL);

    const currentVideoAppointmentId = useVideoCallStore.getState().appointmentId;
    if (!appointmentId || currentVideoAppointmentId !== appointmentId) {
      useVideoCallStore.setState({ meetingData: null, appointmentId: null });
    }

    didResetRef.current = true;
  }
};
